var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ cursor: 'pointer' }),attrs:{"type":"link"},on:{"click":function () { return (this$1.milli = !this$1.milli); }}},[_c('a-statistic',{attrs:{"title":_vm.title,"value":_vm.milli ? _vm.value * 1000 : _vm.value,"suffix":_vm.milli ? _vm.suffixMilli : _vm.suffix,"precision":_vm.milli ? _vm.precision - 3 : _vm.precision}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }